import {useState} from "react";
import axios from "axios";

const useLsWg = ({zoneNo}: {zoneNo: number}) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [response, setResponse] = useState<{no: number; zoneNo: number; id: string; name: string}[]>([]);

    const getWgList = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${process.env.REACT_APP_LS_API_URL}/wg/${zoneNo}`);
            // if (res.data) setResponse(res.data.lines);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    return {wgList: response, wgLoading: loading, getWgList};
};

export {useLsWg};
